import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'emotion';

const wrapperStyle = css`
    max-width: 430px;
`;

export default class SimpleMessage extends React.Component {
    static propTypes = {
        children: PropTypes.any,
        wrapperStyle: PropTypes.string
    };

    render() {
        const className = this.props.wrapperStyle ? this.props.wrapperStyle : wrapperStyle;
        return (
            <div className={cx('simple-message', className)}>
                {this.props.children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/help/SimpleMessage.js